import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import {connect, useDispatch} from 'react-redux';
import {TAB_ENUM} from '../../../Page/SelfCarePage/Constant';
import {PersonalPricePlanStep, messageData, DisplayNameOrNumber, getDisabledError} from '../constant';
import {dwhReportBuilder , reportsDictionary} from '../reportDwh';
import {
  setCurrentStep,
  setMessageData,
  setSelectedPackage,
  getPersonalizedPricePlans,
  saveToHistory,
  fetchPricePlanMetadata,
} from '../personalPricePlanBlockSlice';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
import {setDynamicLoginType} from 'app/Components/Shared/CellcomLayoutPage/startPageSlice';
import {PAGE_LOGIN_TYPE} from 'app/Components/Shared/CellcomLayoutPage/constant';
const PricePlanSelection = (props) => {
  const loginData = props.authentication.loginData;
  const isOtpAuthenticated = loginData.isOtpAuthenticated || loginData.isSilentOtpAuthenticated;
  const isFullAuthenticated = loginData.isFullAuthenticated || loginData.isOtpExtendedAuthenticated;
  const isContactPerson = loginData.isContactPerson;
  const displayName = loginData?.userDetails?.firstName ? loginData?.userDetails?.firstName : loginData?.userDetails?.contactNumber;
  const [clickToContinue, setClickToContinue] = useState(false);
  const [recommendedPricePlans, setRecommendedPricePlans] = useState([]);
  const [shelfPricePlans, setShelfPricePlans] = useState([]);
  const [showSubscribers, setShowSubscribers] = useState(false);
  const {iContent, personalPricePlan} = props;
  const [showAllPricePlans, setShowAllPricePlans] = useState(false);
  const epiPricePlans = iContent?.pricePlansContentArea?.expandedValue || [];


  useEffect(() => {
    dwhReportBuilder(reportsDictionary.OFFER_PAGE_DISPLAY);
    getPersonalizedPricePlans();
  }, []);

  useEffect(() => {
    var recommendationsCode = personalPricePlan.recommendationsPPCode || [];
    if(epiPricePlans.length > 0){
      setRecommendedPricePlans([]);
      setShelfPricePlans([]);
      epiPricePlans.forEach((pricePlan) => classifyPricePlan(pricePlan, recommendationsCode))
    }else{
      props.setMessageData(messageData.ERROR);
      return;
    }
    
  }, [personalPricePlan.recommendationsPPCode]);


  const getPersonalizedPricePlans = async () => {
    if (isNullOrEmpty(personalPricePlan.recommendationsPPCode)) {
      var res = (await props.getPersonalizedPricePlans({ban: props.personalPricePlan.selectedBan}));
      props.saveToHistory(props.personalPricePlan.currentStep);
    }
 
  };

  const classifyPricePlan = (pricePlanFromEpi, recommendations) => {
    const pricePlanCode = pricePlanFromEpi.pricePlanCode?.value || '';
    const isCurrent = props.subscribersList.some((subscriber) => subscriber.currentPricePlan === pricePlanCode);
    if (isCurrent) return false;
    const isRecommended = recommendations?.some((r) => r === pricePlanCode);
    if (isRecommended) {
      var isAlreadyInRecommended = recommendedPricePlans.some((p) => p.pricePlanCode?.value === pricePlanCode);
      setRecommendedPricePlans((prev) => [...prev, pricePlanFromEpi]);
    } else {
      if (pricePlanFromEpi.showIfNotRecomanded?.value) {
        setShelfPricePlans((prev) => [...prev, pricePlanFromEpi]);
      }
    }
  };

  const onSelectedPackage = async (packageData) => {
    dwhReportBuilder(reportsDictionary.OFFER_PAGE_BUTTON_CLICK);
    // Set package first so fetchPricePlanMetadata.fulfilled can merge pricePlanMetadata into it
    props.setSelectedPackage(packageData);
    const res = await props.fetchPricePlanMetadata({offerId: packageData.offerID, ban: props.personalPricePlan.selectedBan});
     var data = res?.payload?.data;
    if (data?.isSuccess) {
      var ppIsBRB = data.is_BRB_PP;
      if (ppIsBRB) {
        var allSubscribersValid = props.subscribersList.every((subscriber) => !getDisabledError(subscriber));
        if (!allSubscribersValid) {
          var isBRB_BAN = personalPricePlan.productsByBan.find((b) => b.ban == personalPricePlan.selectedBan)?.brb_Ind;
          if(isBRB_BAN){
            props.setMessageData(messageData.CANNOT_CHANGE_FAMILY_PLAN);  
            return;
          }
        }
      }
    
    if (isOtpAuthenticated) {
      props.setDynamicLoginType(PAGE_LOGIN_TYPE.OTP_EXTENDED);
      dwhReportBuilder(reportsDictionary.POPUP_OTP_EXTENDED_DISPLAY);
    }else{
      props.setCurrentStep(PersonalPricePlanStep.SelectSubscribers);
    }
  }
  };

  const ppToShow = (recommendedPricePlans.length == 0 || showAllPricePlans) ? [...recommendedPricePlans, ...shelfPricePlans] : recommendedPricePlans;
 

 
  return (
    <div className='price-plan-selection'>
      <div className='title'>
        {` ${displayName}, יש לנו חבילות `}
        שמתאימות בדיוק בשבילך
      </div>
      {(!isOtpAuthenticated && props.subscribersList.length > 1) && (
        <div className='link' onClick={() => setShowSubscribers(true)}>
          רשימת המנויים שלך
        </div>
      )}
      {showSubscribers && (
        <div className='subscribers-list-popup'>
          <div className='close-icon' onClick={() => setShowSubscribers(false)}>
            <Image src={require('../icons/close.svg')} alt='close' />
          </div>
          {props.subscribersList.map((subscriber) => {
            const displayName = DisplayNameOrNumber(subscriber);

            return (
              <div className='subscriber-item' key={subscriber.subscriberNo}>
                <div className='subscriber-name'>{displayName}</div>
                {!isNullOrEmpty(subscriber.productFirstName) && <div className='subscriber-no'>{subscriber.subscriberNo}</div>}
              </div>
            );
          })}
        </div>
      )}
      {ppToShow && <SalePackages packages={{salePackages:  ppToShow}} context={props.context} onSelectedPackages={onSelectedPackage} />}
      {shelfPricePlans.length > 0 && !showAllPricePlans && recommendedPricePlans.length > 0 && (
        <div className='link' onClick={() => setShowAllPricePlans(true)}> לכל החבילות </div>
      )}
  
    </div>
  );
};
const mapStateToProps = (state) => ({
  authentication: state.authentication,
  personalPricePlan: state.personalPricePlan,
  subscribersList: state.personalPricePlan.subscribersList,
});

const mapDispatchToProps = {
  setCurrentStep,
  setMessageData,
  setSelectedPackage,
  getPersonalizedPricePlans,
  setDynamicLoginType,
  saveToHistory,
  fetchPricePlanMetadata,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricePlanSelection);
